(function() {
  // Function to wrap the inner text of an element in a <span>
  function wrapElementText(el) {
    // Ensure the element has actual text, isn't already wrapped, and is a button
    if (el && el.textContent.trim() && !el.querySelector('span')) {
      
      // Extract the current contents (preserves text and minor nested elements)
      const fragment = document.createDocumentFragment();
      while (el.firstChild) {
        fragment.appendChild(el.firstChild);
      }
      
      // Create the new span element
      const span = document.createElement('span');
      span.className = 'slider_ele_wrapped-inner'; 
      span.appendChild(fragment);
      
      // Append back into clean element
      el.appendChild(span);
    }
  }

  // Scan and target elements on initial load
  function processExisting() {
    document.querySelectorAll('button, .button, [class*="klaviyo-form-button"]').forEach(wrapElementText);
  }

  // Watch for dynamic updates reliably
  const observer = new MutationObserver((mutations) => {
    // Optimize performance: just re-query for unwrapped targets when layout changes
    const buttons = document.querySelectorAll('button:not(:has(span)), .button:not(:has(span)), [class*="klaviyo-form-button"]:not(:has(span))');
    buttons.forEach(wrapElementText);
  });

  // Initialize execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processExisting);
  } else {
    processExisting();
  }

  // Start active tracking across the entire document tree
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
class HorizonHoverQuickAdd {
  constructor() {
    this.productData = {};
    this.init();
    this.initObserver();
  }

  // init() {
  //   document.addEventListener('click', (e) => {
  //     if (e.target.closest('[data-drawer-close-mask]')) {
  //       e.preventDefault();
  //       this.closeAllActiveDrawers();
  //       return;
  //     }

  //     const triggerBtn = e.target.closest('[data-trigger-expansion-btn]');
  //     if (triggerBtn) {
  //       e.preventDefault();
  //       e.stopPropagation();
        
  //       const container = triggerBtn.closest('.product-card-quick-add');
  //       const isMultiVariant = container?.dataset.hasVariants === 'true';
        
  //       if (isMultiVariant) {
  //         this.closeAllActiveDrawers();
  //         const targetPanel = container.querySelector('.quick-add-expanded-drawer-panel');
  //         if (targetPanel) targetPanel.classList.add('is-open');
  //       } else {
  //         const parentId = container?.dataset.product;
  //         if (parentId) this.handleAddToCart(container, parentId, triggerBtn);
  //       }

  //       document.querySelectorAll('.product-grid__item').forEach(slide => {
  //           slide.classList.remove('quick-add-open');
  //       });
  //       const parentSlideColl = triggerBtn.closest('.product-grid__item'); 

  //       if (parentSlideColl) {
  //           parentSlideColl.classList.add('quick-add-open');
  //       }

  //       document.querySelectorAll('.resource-list__slide').forEach(slide => {
  //           slide.classList.remove('quick-add-open');
  //       });
  //       const parentSlideCollR = triggerBtn.closest('.resource-list__slide'); 

  //       if (parentSlideCollR) {
  //           parentSlideCollR.classList.add('quick-add-open');
  //       }

  //       return;
  //     }

  //     const submitBtn = e.target.closest('[data-submit-button]');
  //     if (submitBtn) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       const parent = submitBtn.closest('.product-card-quick-add');
  //       if (parent?.dataset.product) {
  //         this.handleAddToCart(parent, parent.dataset.product, submitBtn);
  //       }
  //     }
  //   }, true);

  //   document.addEventListener('keydown', (e) => {
  //     if (e.key === 'Escape') this.closeAllActiveDrawers();
  //   });

  //   document.addEventListener('change', (e) => {
  //     if (e.target.matches('.product-card-quick-add input[type="radio"]')) {
  //       const container = e.target.closest('.product-card-quick-add');
  //       const productId = container?.dataset.product;
  //       if (container && productId && this.productData[productId]) {
  //         this.updateOptionsAvailability(container, this.productData[productId]);
  //       }
  //     }
  //   });
  // }

 init() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-close-mask]')) {
        e.preventDefault();
        this.closeAllActiveDrawers();
        return;
      }

      const triggerBtn = e.target.closest('[data-trigger-expansion-btn]');
      if (triggerBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = triggerBtn.closest('.product-card-quick-add');
        const isMultiVariant = container?.dataset.hasVariants === 'true';
        const isMobile = window.innerWidth < 768;
        
        if (isMultiVariant) {
          this.closeAllActiveDrawers();
          
          let targetPanel = container.querySelector('.quick-add-expanded-drawer-panel');
          
          if (isMobile && targetPanel) {
            targetPanel.setAttribute('data-associated-product', container.dataset.product);
            document.body.appendChild(targetPanel);
          } else if (isMobile) {
            targetPanel = document.querySelector(`.quick-add-expanded-drawer-panel[data-associated-product="${container.dataset.product}"]`);
          }
          
          if (targetPanel) {
            setTimeout(() => {
              targetPanel.classList.add('is-open');
            }, 10);
          }
        } else {
          const parentId = container?.dataset.product;
          if (parentId) this.handleAddToCart(container, parentId, triggerBtn);
        }

        document.querySelectorAll('.product-grid__item').forEach(slide => {
            slide.classList.remove('quick-add-open');
        });
        const parentSlideColl = triggerBtn.closest('.product-grid__item'); 

        if (parentSlideColl) {
            parentSlideColl.classList.add('quick-add-open');
        }

        document.querySelectorAll('.resource-list__slide').forEach(slide => {
            slide.classList.remove('quick-add-open');
        });
        const parentSlideCollR = triggerBtn.closest('.resource-list__slide'); 

        if (parentSlideCollR) {
            parentSlideCollR.classList.add('quick-add-open');
        }

        return;
      }

      const submitBtn = e.target.closest('[data-submit-button]');
      if (submitBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const panel = submitBtn.closest('.quick-add-expanded-drawer-panel');
        let parent = submitBtn.closest('.product-card-quick-add');
        
        if (!parent && panel) {
          const assocId = panel.getAttribute('data-associated-product');
          parent = document.querySelector(`.product-card-quick-add[data-product="${assocId}"]`);
        }
        
        // FIX: If the panel was moved to the body on mobile, read the checked radio options 
        // directly out of the panel container where they now live, not the empty parent card.
        const inputSourceContainer = (window.innerWidth < 768 && panel) ? panel : parent;
        const targetId = parent ? parent.dataset.product : panel?.getAttribute('data-associated-product');
        
        if (targetId && inputSourceContainer) {
          this.handleAddToCart(inputSourceContainer, targetId, submitBtn);
        }
      }
    }, true);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeAllActiveDrawers();
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('.quick-add-expanded-drawer-panel input[type="radio"]')) {
        const panel = e.target.closest('.quick-add-expanded-drawer-panel');
        const assocId = panel.getAttribute('data-associated-product');
        
        // FIX: Ensure option availability calculations query the active panel layout container on mobile
        const container = (window.innerWidth < 768 && panel) ? panel : (document.querySelector(`.product-card-quick-add[data-product="${assocId}"]`) || panel);
        
        if (assocId && this.productData[assocId]) {
          this.updateOptionsAvailability(container, this.productData[assocId]);
        }
      }
    });
  }

  closeAllActiveDrawers() {
    document.querySelectorAll('.quick-add-expanded-drawer-panel.is-open').forEach(panel => {
      panel.classList.remove('is-open');
    });
  }

  initObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector('.product-card-quick-add')) {
            this.loadProductData(node.querySelector('.product-card-quick-add'));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll('.product-card-quick-add').forEach(card => this.loadProductData(card));
  }

  loadProductData(parentContainer) {
    const productId = parentContainer.dataset.product;
    const productHandle = parentContainer.dataset.handle;
    
    if (productHandle && !this.productData[productId]) {
      fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(data => { 
          this.productData[productId] = data;
          this.selectFirstAvailableVariant(parentContainer, data);
          this.updateOptionsAvailability(parentContainer, data);
        })
        .catch(err => console.error("QuickAdd JSON stream issue:", err));
    }
  }

  selectFirstAvailableVariant(container, product) {
    // Find the first available variant, fallback to first overall variant if completely sold out
    const targetVariant = product.variants.find(v => v.available) || product.variants[0];
    if (!targetVariant) return;

    // Synchronize radio buttons to match this chosen variant's option values
    targetVariant.options.forEach((optionValue, index) => {
      const groupIndex = `option${index + 1}`;
      const radio = container.querySelector(`.option-group[data-option-index="${groupIndex}"] input[type="radio"][value="${CSS.escape(optionValue)}"]`);
      if (radio) {
        radio.checked = true;
      }
    });
  }

  updateOptionsAvailability(container, product) {
    const optionGroups = Array.from(container.querySelectorAll('.option-group'));
    if (!optionGroups.length) return;

    const currentSelections = {};
    optionGroups.forEach(group => {
      const checkedInput = group.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        currentSelections[group.dataset.optionIndex] = checkedInput.value;
      }
    });

    optionGroups.forEach(group => {
      const groupIndex = group.dataset.optionIndex;
      const radios = group.querySelectorAll('input[type="radio"]');

      radios.forEach(radio => {
        const valueToTest = radio.value;
        const testConfiguration = { ...currentSelections, [groupIndex]: valueToTest };

        const isCombinationAvailable = product.variants.some(variant => {
          const matchOption1 = testConfiguration.option1 ? variant.option1 === testConfiguration.option1 : true;
          const matchOption2 = testConfiguration.option2 ? variant.option2 === testConfiguration.option2 : true;
          const matchOption3 = testConfiguration.option3 ? variant.option3 === testConfiguration.option3 : true;
          return matchOption1 && matchOption2 && matchOption3 && variant.available;
        });

        const labelWrap = radio.closest('.option-value');
        if (isCombinationAvailable) {
          labelWrap.classList.remove('disabled');
          radio.disabled = false;
        } else {
          labelWrap.classList.add('disabled');
          radio.disabled = true;
        }
      });
    });

    const selectedOptions = Array.from(container.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
    const activeVariant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
    const submitPriceText = container.querySelector('[data-submit-button] .btn-text-right');
    
    if (activeVariant && submitPriceText) {
      if (window.Shopify && Shopify.formatMoney) {
        submitPriceText.innerHTML = Shopify.formatMoney(activeVariant.price);
      } else {
        const formattedPrice = (activeVariant.price / 100);
        submitPriceText.innerHTML = `£${formattedPrice}`;
      }
    }
  }

  async handleAddToCart(container, productId, targetButtonElement) {
    const submitBtn = targetButtonElement || container.querySelector('[data-submit-button]') || container.querySelector('.direct-add-single-variant-btn');
    
    submitBtn.disabled = true;
    const originalContent = submitBtn.innerHTML;
    
    if (submitBtn.querySelector('.btn-text-left')) {
      submitBtn.querySelector('.btn-text-left').innerHTML = 'adding...';
    } else {
      submitBtn.innerHTML = `<span>adding...</span>`;
    }

    const productHandle = container.dataset.handle;
    
    if (!this.productData[productId]) {
      try {
        const fallbackResponse = await fetch(`/products/${productHandle}.js`);
        this.productData[productId] = await fallbackResponse.json();
      } catch (fetchErr) {
        console.error("Fallback item data fetch failed:", fetchErr);
      }
    }

    const product = this.productData[productId];
    let variantId = null;

    if (!product || (product.options.length === 1 && product.options[0].name === "Title" && product.options[0].values[0] === "Default Title")) {
      variantId = product ? product.variants[0].id : parseInt(container.dataset.variantId || productId);
    } else {
      const selectedOptions = Array.from(container.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
      const activeVariant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
      if (activeVariant) variantId = activeVariant.id;
    }

    if (!variantId || isNaN(variantId)) {
      console.error("Could not find a valid variant ID for submission");
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalContent;
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'items': [{ 'id': parseInt(variantId), 'quantity': 1 }] })
      });

      if (!response.ok) throw new Error('Cart submission error');

      const cart = await response.json();
      const cartData = await fetch('/cart.js').then(res => res.json());

      document.dispatchEvent(new CustomEvent('cart:update', { 
        bubbles: true, 
        detail: { data: { item_count: cartData.item_count, items: cart.items } } 
      }));

      this.closeAllActiveDrawers();

      const drawer = document.querySelector('cart-drawer-component') || document.querySelector('#CartDrawer');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.setAttribute('open', '');
      }

    } catch (err) {
      console.error("Cart API Error:", err);
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalContent;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HorizonHoverQuickAdd());
} else {
  new HorizonHoverQuickAdd();
}


// const observer = new MutationObserver((mutations, obs) => {
//   const button = document.querySelector('button.btn.pplr-c-button.pplr-btn.ptc_button');
  
//   if (button) {
//     button.addEventListener('click', () => {
//       if (button.classList.contains('pplr_remove')) {
//         document.body.classList.add('no-personalizer');
//         document.body.classList.remove('itspersonalizer');
//       } else {
//         document.body.classList.add('itspersonalizer');
//         document.body.classList.remove('no-personalizer');
//       }
//     });
//     // Disconnect observer once we've successfully bound the event
//     obs.disconnect(); 
//   }
// });

function checkButtonState() {
  const button = document.querySelector('button.ptc_button');
  
  if (button) {
    if (button.classList.contains('pplr_remove')) {
      document.body.classList.add('ele_no-personalizer');
      document.body.classList.remove('ele_itspersonalizer');
    } else {
      document.body.classList.add('ele_itspersonalizer');
      document.body.classList.remove('ele_no-personalizer');
    }
    // Return true so we know we found it and can disconnect
    return true;
  }
  return false;
}

const observer = new MutationObserver((mutations, obs) => {
  // Every time the DOM changes or an attribute updates, check for the button
  if (checkButtonState()) {
    obs.disconnect(); // Stop watching once the button is found and state is set
  }
});

// Run an immediate check in case it managed to load before the script
if (!checkButtonState()) {
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true // Added this to catch apps that modify existing elements
  });
}


// 1. Handle ALL clicks via Event Delegation (No observer needed for clicks)
document.body.addEventListener('click', (e) => {
  const mainButton = e.target.closest('button.btn.pplr-c-button.pplr-btn.ptc_button');
  
  if (mainButton && !mainButton.closest('.pplr_crop-modal')) {
    // This is the main button click!
    console.log('Main button clicked');
    
    // Force a check for the modal text shortly after the click
    setTimeout(fixModalText, 100);
    setTimeout(fixModalText, 400); // Back-up if modal animations take time
  }
});

// 2. The Text Fixing Function
function fixModalText() {
  const modalButton = document.querySelector('.pplr_crop-modal button.btn.pplr-c-button.pplr-btn.ptc_button');
  if (modalButton) {
    const innerSpan = modalButton.querySelector('.slider_ele_wrapped-inner');
    if (innerSpan) {
      innerSpan.textContent = 'ADD TO BASKET';
    } else {
      modalButton.textContent = 'ADD TO BASKET';
    }
  }
}

// 3. Fallback: Run the text fix on a continuous loop ONLY when the modal is open 
// This completely stops the App's internal scripts from overriding your text
setInterval(() => {
  if (document.querySelector('.pplr_crop-modal')) {
    fixModalText();
  }
}, 250);





$(document).ready(function() {
    var chainObj = {};
    var elementsArray = [];

    // 1. Addon Button Click Handler with Disabled Guard
    $('button.bundle_addon_button').click(function(e) {
      // Prevent clicks on disabled buttons
      if ($(this).is(':disabled') || $(this).prop('disabled') || $(this).hasClass('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      if ($(this).hasClass('special_color_item')) {
        $('.bundle_addon_button').removeClass('active');
        $(this).addClass('active');  
      } else {
        $(this).toggleClass('active');    
      }

      if ($(this).hasClass('active')) {
        var src = $(this).attr('datasrc');
        var datatitle = $(this).attr('datatitle');
        var vid = $(this).attr('dataid');
        var vprice = parseFloat($(this).attr('dataprice'));
        chainObj = {
          "src": src,
          "vid": vid,
          "datatitle": datatitle,
          "vprice": vprice
        };
        $('.chain_count strong').html('£'+(vprice/100));
        $('.chain_count span').html('1');
      } else {
        chainObj = {};
        $('.chain_in').remove();
        $('.bundle_addon_button').removeClass('active');
        $('.chain_count span').html('0');
        $('.chain_count strong').html('0');
      }
      renderBundleElements();
    });

    // 2. Render Bundle Elements & Dynamic Submit Button State
    function renderBundleElements() {
      var selected_items = '';
      
      // Check if current active chain button is disabled
      var $activeChainBtn = $('button.bundle_addon_button.active');
      var isChainDisabled = $activeChainBtn.length > 0 && ($activeChainBtn.is(':disabled') || $activeChainBtn.prop('disabled'));

      if (chainObj && chainObj.vid) {
        $('.selected_items_ele').addClass('active');
        selected_items += '<li class="chain_in"> <img src="'+chainObj.src+'">';
        if (elementsArray && elementsArray.length > 0) {
          selected_items += '<li class="chain_in"> <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none"> <path d="M19.433 20.8534H15.377V19.0774H19.433V15.0454H21.209V19.0774H25.217V20.8534H21.209V24.8854H19.433V20.8534Z" fill="#BBBBBB"></path> </svg> </li>';
        }
      } else {
        $('.selected_items_ele').removeClass('active');
        $('.chain_in').remove();
      }

      var elementsTotal = 0;
      if (elementsArray && elementsArray.length > 0) {
        $('.selected_items_ele').addClass('active');
        elementsArray.forEach(function(v, i) {
          elementsTotal = parseFloat(elementsTotal) + parseFloat(v.vprice);
          if (v && v.src) {
            selected_items += '<li> <img src="'+v.src+'"> <button class="remove_selected_from_pack" dataindex="'+i+'" dataid="'+v.vid+'">Remove</button> </li>';
          } else {
            selected_items += '<li> <span class="vtitle_wrp_title">'+v.vtitle+'</span> <button class="remove_selected_from_pack" dataindex="'+i+'" dataid="'+v.vid+'">Remove</button> </li>';
          }
        });
        var elementsTotalFinal = '£'+(elementsTotal/100).toFixed(2);
        $('.letters_count strong').html(elementsTotalFinal.replace('.00', ''));
      } else {
        if (chainObj && chainObj.vid) {} else {
          $('.selected_items_ele').removeClass('active');
        }
      }

      var totalBundlePrice = elementsTotal;
      if (chainObj && chainObj.vprice) {
        totalBundlePrice = parseFloat(elementsTotal) + parseFloat(chainObj.vprice);
      }
      var totalBundlePriceFinal = '£'+(totalBundlePrice/100);
      $('.total_bundle_price').html(totalBundlePriceFinal);
      setTimeout(() => {
        $('.tsuffix_bundle .product-details .price__regular .price').html(totalBundlePriceFinal);
      }, 50);

      $('.letters_count span').html(elementsArray.length);
      $('.selected_items_ele_in ul').html(selected_items);

      // --- ADD TO BASKET BUTTON DISABLE / ENABLE LOGIC ---
      var $submitBtn = $('.product-bundle_form__submit');
      if (isChainDisabled || (elementsArray.length === 0 && (!chainObj || !chainObj.vid))) {
        $submitBtn.prop('disabled', true).addClass('disabled');
      } else {
        $submitBtn.prop('disabled', false).removeClass('disabled');
      }
    }

    // Helper Function
    function removeObjectWithId(arr, id) {
      const objWithIdIndex = arr.findIndex((obj) => obj.vid === id);
      if (objWithIdIndex > -1) {
        arr.splice(objWithIdIndex, 1);
      }
      return arr;
    }

    // --- TRIGGER FIRST AVAILABLE COLOR ON LOAD ---
    var $firstAvailableBtn = $('.bundle_addon_button.special_color_item:not(:disabled):not(.disabled):first');
    if ($firstAvailableBtn.length > 0) {
      $firstAvailableBtn.trigger('click');
    } else {
      // If all color items are out of stock / disabled
      $('.product-bundle_form__submit').prop('disabled', true).addClass('disabled');
    }

    // Variant Label Click Handler
    $(document).on('click', '.tsuffix_bundle .variant_wrp_ele label.variant-option__button-label', function(e) {
      e.preventDefault();

      $('.tsuffix_bundle .variant_wrp_ele label.variant-option__button-label').removeClass('active');
      $(this).addClass('active');
      var $label = $(this);
      var $input = $label.find('input');

      if ($label.hasClass('disabled_label') || $input.is(':disabled')) {
        return;
      }

      var src = $input.attr('src') || $input.find('img').attr('src') || '';
      var vid = $input.attr('data-variant-id') || $label.attr('vid') || '';
      var vprice = $input.attr('data-variant-price') || '0';
      var vtitle = $input.attr('vtitle') || $.trim($label.text());
      var vavailable = parseInt($label.attr('vavailable'));

      if (isNaN(vavailable)) vavailable = 999;

      if (!vid) {
        console.log('Missing VID → FIX YOUR HTML');
        return;
      }

      var data_element = {
        src: src,
        vid: vid,
        vprice: vprice,
        vtitle: vtitle
      };

      if (elementsArray.length < 6) {
        elementsArray.push(data_element);
        renderBundleElements();
      } else {
        $('.errorshow').text('max 6 charms allowed.');
        setTimeout(function() {
          $('.errorshow').text('');
        }, 4000);
      }
    });

    // Remove Charm
    $(document).on('click', 'button.remove_selected_from_pack', function() {
      var id = $(this).attr('dataid');
      elementsArray = removeObjectWithId(elementsArray, id);
      renderBundleElements();
    });

    // Remove Chain
    $(document).on('click', 'button.remove_selected_chain_from_pack', function() {
      $('.chain_in').remove();
      $('.bundle_addon_button').removeClass('active');
      $('.chain_count span').html('0');
      $('.chain_count strong').html('0');
      chainObj = {};
      renderBundleElements();
    });

    // Submit Bundle to Cart AJAX
    $('.product-bundle_form__submit').click(function(e) {  
      e.preventDefault();
      e.stopPropagation();
      var that = $(this);
      
      if ($(this).is(':disabled') || $(this).prop('disabled')) {              
        return;
      }

      var items_f = [];
      var chainObjCheck = false;
      if (chainObj && chainObj.vid) {
        chainObjCheck = true;
      }

      if (elementsArray.length === 0 && !chainObjCheck) {
        return;
      }

      $(this).find('span').text('adding...');

      var vstring = '';
      var properties_ref_order = {};
      elementsArray.forEach(function(v, i) {
        vstring = vstring + ' ' + v.vtitle;
      });

      if (vstring !== '') {
        properties_ref_order = {
          "Letters Order": vstring
        };
      }

      if (chainObj && chainObj.vid) {
        var current_pro = {
          id: chainObj.vid,
          quantity: 1,
          properties: properties_ref_order
        };
        items_f.push(current_pro);
      }

      var properties_ref = {};
      if (chainObj && chainObj.datatitle) {
        properties_ref = {
          'Ref': chainObj.datatitle + '-' + chainObj.vid
        };
      }

      elementsArray.forEach(function(v, i) {
        var current_pro = {
          id: v.vid,
          quantity: 1,
          properties: properties_ref
        };
        items_f.push(current_pro);
      });

      var data = {
        items: items_f
      };

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(cartItem) {
          $.getJSON('/cart.js', function(cartData) {
            document.dispatchEvent(new CustomEvent('cart:update', { 
              bubbles: true, 
              detail: { 
                data: { 
                  item_count: cartData.item_count, 
                  items: cartItem.items || [cartItem] 
                } 
              } 
            }));

            if ($('.cart-count-bubble')[0]) {
              $('.cart-count-bubble span').html(cartData.item_count);
            } else {
              var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cartData.item_count+'</span><span class="visually-hidden">'+cartData.item_count+' item</span> </div>';
              $('#cart-icon-bubble').append(dt);
            }
          });

          that.find('span').show();
          that.find('.loading__spinner').addClass('hidden');
          $('.modal').removeClass('is-visible');

          $('cart-drawer').addClass('animate active');

          const customDrawer = document.querySelector('cart-drawer-component') || document.querySelector('#CartDrawer');
          if (customDrawer && typeof customDrawer.open === 'function') {
            customDrawer.open();
          } else if (customDrawer) {
            customDrawer.setAttribute('open', '');
          }

          elementsArray = [];
          renderBundleElements();

          that.find('span').text('add to basket');
        },
        error: function(err) {
          console.log(err);      
          if (err && err.responseJSON && err.responseJSON.description) {
            $('.product-form__submit_builder').after('<p class="error">'+err.responseJSON.description+'</p>');
            setTimeout(function() {
              $('.error').remove();
            }, 2500);
          }
          that.find('span').text('add to basket');      
        }
      });
    });  
});




(function() {
if (window.innerWidth > 768) {
    return;
  }
  // 2. Initialize Swiper engine on the scoped container
  function initCharmSlider(container) {
    if (container.classList.contains('swiper-initialized')) return;

    // Add Swiper layout markers
    container.classList.add('swiper');
    
    // Wrap buttons inside a swiper-wrapper div if not already present
    let wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      while (container.firstChild) {
        wrapper.appendChild(container.firstChild);
      }
      container.appendChild(wrapper);
    }

    // Add the slide layout class to individual buttons
    container.querySelectorAll('.variant-option__button-label').forEach(slide => {
      slide.classList.add('swiper-slide');
    });

    // Append Swiper scrollbar element dynamically
    let scrollbar = container.querySelector('.swiper-scrollbar');
    if (!scrollbar) {
      scrollbar = document.createElement('div');
      scrollbar.className = 'swiper-scrollbar';
      container.appendChild(scrollbar);
    }

    // Initialize Swiper
    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
        hide: false
      },
      watchOverflow: true
    });
  }

  // 3. Keep an eye out for the elements using your specific selector context
    const checkInterval = setInterval(() => {
      const container = document.querySelector('.tsuffix_bundle .variant_wrp_ele');
      if (container && container.querySelectorAll('.variant-option__button-label').length > 0) {
        initCharmSlider(container);
      }
    }, 400);

    // Clear interval after 12 seconds to prevent memory lag
    setTimeout(() => clearInterval(checkInterval), 12000);
})();
